import { FLOOR_PREP_PRODUCTS, EPOXY_PRIMERS, DESIGN_COAT_PRODUCTS, PIGMENTS_PRODUCTS, TOP_COAT_PRODUCTS, HIGH_BUILD_EPOXY, FLAKE_PRODUCTS, POLYASPARTIC_SEAL } from './productData';

/** Every product / pack combination the ProEpoxy order builder can put on an order — same strings the steps emit. */
export function enumerateProEpoxyItems() {
  const out = [];
  const add = (category, product_name, pack_label = null) => out.push({ category, product_name, pack_label });
  const m2 = (size) => `${size}m² pack`;

  FLOOR_PREP_PRODUCTS.smoothing_compounds.forEach((p) => add('floor_prep', p.name));
  FLOOR_PREP_PRODUCTS.primers.forEach((p) => add('floor_prep', p.name));

  Object.values(EPOXY_PRIMERS).forEach((pr) => pr.colors.forEach((c) => pr.packs.forEach((pk) => add('primer', `${pr.name} (${c})`, m2(pk.size)))));

  DESIGN_COAT_PRODUCTS.comfort.packs.forEach((pk) => add('design_coat', DESIGN_COAT_PRODUCTS.comfort.name, m2(pk.size)));
  add('design_coat', DESIGN_COAT_PRODUCTS.crystal.name);

  PIGMENTS_PRODUCTS.metallicPowder.colors.forEach((c) => PIGMENTS_PRODUCTS.metallicPowder.sizes.forEach((s) => add('pigment', `Metallic Pigment Powder - ${c}`, s.size)));
  PIGMENTS_PRODUCTS.pigmentPaste.colors.forEach((c) => PIGMENTS_PRODUCTS.pigmentPaste.packs.forEach((pk) => add('pigment', `Pigment Paste - ${c}`, m2(pk.size))));
  PIGMENTS_PRODUCTS.glitter.types.forEach((t) => PIGMENTS_PRODUCTS.glitter.packs.forEach((pk) => add('pigment', t, m2(pk.size))));
  PIGMENTS_PRODUCTS.sprays.marbleSpray.colors.forEach((c) => add('pigment', `Marble Spray - ${c}`));
  PIGMENTS_PRODUCTS.sprays.metallicSpray.colors.forEach((c) => add('pigment', `Metallic Spray - ${c}`));

  Object.values(TOP_COAT_PRODUCTS).forEach((tc) => tc.finishes.forEach((f) => tc.packs.forEach((pk) => add('top_coat', `${tc.name} (${f})`, m2(pk.size)))));
  POLYASPARTIC_SEAL.packs.forEach((pk) => add('top_coat', POLYASPARTIC_SEAL.name, m2(pk.size)));

  HIGH_BUILD_EPOXY.colors.forEach((c) => HIGH_BUILD_EPOXY.packs.forEach((pk) => add('high_build', `${HIGH_BUILD_EPOXY.name} (${c.code})`, m2(pk.size))));
  FLAKE_PRODUCTS.allColors.forEach((c) => add('high_build', `Flake — ${c.name}`));

  const seen = new Set();
  return out.filter((i) => { const k = `${i.product_name}|${i.pack_label || ''}`.toLowerCase(); if (seen.has(k)) return false; seen.add(k); return true; });
}

export const PROEPOXY_CATEGORY_LABEL = { floor_prep: 'Floor prep', primer: 'Primers', design_coat: 'Design coats', pigment: 'Pigments, glitter & sprays', top_coat: 'Top coats', high_build: 'High build & flake' };
